/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { registerLocaleData } from '@angular/common';
import localeMs from '@angular/common/locales/ms';

registerLocaleData(localeMs);

bootstrapApplication(AppComponent, appConfig)
  .catch(err => console.error(err));

